import { useState } from 'react';
import { partners } from '../../assets';
import SectionHeading from '../common/SectionHeading';
import { X, ZoomIn } from 'lucide-react'; // For the modal close and icon hint

const TrustSectiion = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Note: Ensure 'partners' is an Array in your assets/index.js as discussed previously
  const partnersArray = Array.isArray(partners) ? partners : Object.values(partners);

  return (
    <>
      <section className="relative md:py-20 py-10 px-5 bg-gray-200">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-16">
            
            {/* Left Content: Partner Logos */}
            <div className="w-full lg:w-2/3">
              <div className="mb-12">
                <SectionHeading 
                  subtitle="Our Network" 
                  title="Trusted Logistics Partner" 
                />
              </div>

              {/* Logo Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-10 items-center justify-items-center bg-white p-10 rounded-3xl border border-gray-100 shadow-sm">
                {partnersArray.map((partner, index) => (
                  <div key={index} className="group relative cursor-pointer">
                    <img
                      src={partner}
                      alt={`Partner logo ${index}`}
                      className="w-24 h-auto gh:scale-110 transition-all duration-500 ease-in-out"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Content: Certificate Preview */}
            <div className="w-full lg:w-1/3 flex flex-col items-center">
              <div className="relative group cursor-pointer" onClick={() => setIsModalOpen(true)}>
                {/* Decorative glow behind certificate */}
                <div className="absolute -inset-2 bg-brand-500/20 rounded-2xl blur-xl opacity-0 gh:opacity-100 transition-opacity duration-500"></div>
                
                <div className="relative overflow-hidden rounded-2xl shadow-xl border-4 border-white transition-transform duration-500 gh:-rotate-2 gh:scale-105">
                  <img
                    className="w-full max-w-[300px] h-auto"
                    src="/assets/images/bluedart-certificate.png"
                    alt="bluedart certificate"
                  />
                  
                  {/* Hover Overlay with Zoom Icon */}
                  <div className="absolute inset-0 bg-brand-900/40 flex items-center justify-center opacity-0 gh:opacity-100 transition-opacity duration-300">
                    <div className="bg-white/20 backdrop-blur-md p-3 rounded-full text-white border border-white/30">
                      <ZoomIn size={24} />
                    </div>
                  </div>
                </div>
                
                <p className="mt-4 text-center font-bold text-gray-400 uppercase text-[10px] tracking-widest Ethnocentric">
                  Click to View Certificate
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Tailwind Modal Overlay */}
      {isModalOpen && (
        <div 
          className="fixed inset-0 z-10000 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm animate-in fade-in duration-300"
          onClick={() => setIsModalOpen(false)}
        >
          {/* Close Button */}
          <button className="absolute top-6 right-6 text-white/50 ha:text-white transition-colors">
            <X size={40} />
          </button>

          <div 
            className="relative max-w-4xl w-full flex justify-center animate-in zoom-in-95 duration-300"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image
          >
            <img
              src="/assets/images/bluedart-certificate.png"
              alt="Full Certificate"
              className="max-h-[90vh] w-auto rounded-lg shadow-2xl border-2 border-white/10"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default TrustSectiion;